import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createAdminLegalEntity,
  fetchAdminLegalEntities,
  updateAdminLegalEntity,
  type AdminLegalEntityPayload,
} from "@/api/adminCenter";

const LE_KEY = ["adminCenter", "legalEntities"] as const;

/** G2-S3 — admin LE governance list (admin-only; skip for non-admin to avoid 403). */
export function useAdminLegalEntities(enabled = true) {
  return useQuery({
    queryKey: LE_KEY,
    queryFn: ({ signal }) => fetchAdminLegalEntities(signal),
    staleTime: 15_000,
    enabled,
  });
}

export function useCreateLegalEntity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: AdminLegalEntityPayload) => createAdminLegalEntity(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: LE_KEY }),
  });
}

export function useUpdateLegalEntity() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: AdminLegalEntityPayload }) =>
      updateAdminLegalEntity(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: LE_KEY }),
  });
}
